import { Component } from '@angular/core';


import {CommonModule} from '@angular/common';


// Angular material components
import {MatButtonModule} from '@angular/material/button';



// Services 
import { UserAuthenticationService } from '../../../services/firestore/user-authentication.service';
import { LanguageService } from '../../../services/language/language.service';
import { GlobalVariables } from '../../../constants/global';
import { UtilsService } from '../../../services/utils/utils.service';








@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule, 
    MatButtonModule,
    // Custom modules
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPageComponent {



  constructor(
    public userAuthenticationService:UserAuthenticationService,
    public languageService:LanguageService,
    public utilsService:UtilsService
  ){}




  async loginButtonclicked(targetProvider:string){
    // Try to log in and wait for the response
    // Response:
    // {resultOk:bool, error:firebase-error)}
    var resultDict:any = await this.userAuthenticationService.login(targetProvider)
    if(resultDict['resultOk'] == true){}
    else if(resultDict['resultOk'] == false){
      this.utilsService.displaySnackBar(this.languageService.Strings.loginPageStrings.login_error_unauthorized)
    }else{
      this.utilsService.displaySnackBar(this.languageService.Strings.loginPageStrings.loginErrorUnknown)
    }     
  }
  


}